export default {
    txt_welcome: 'Mile widziany',
    txt_dataover: 'Przegląd danych',
    txt_chance: 'Okazja',
    txt_device: 'Urządzenie',
    txt_chinese: '中文-Chinese',
    txt_english: '英文-English',
    txt_malay: '马来语-Malay',
    txt_reports: 'Historia',
    txt_setting: 'Ustawienie',
    txt_dymanager: 'Kierownictwo urzędnicze',
    txt_account: 'Identyfikator:Konto',
    txt_userstatus: 'Tożsamość użytkownika',
    txt_name: 'Nazwa',
    txt_contactway: 'Dane kontaktowe',
    txt_accountsafe: 'Zabezpieczenie konta',
    txt_basicinfo: 'Istotne informacje',
    txt_updatepassword: 'Modyfikacja hasła',
    txt_storeinfomation: 'Informacje o sklepie',
    txt_storename: 'Serwis',
    txt_storephone: 'Numer telefonu sklepu ',
    txt_storeaddress: 'Adres serwisu',
    txt_AppInfomation: 'App',
    txt_currentversion: 'Aktualna wersja',
    txt_software: 'Aktualizacja oprogramowania',
    txt_loginout: 'Zakończ logowanie',
    txt_updatelanguage: 'Język',
    txt_updateto: 'Zaktualizuj do',
    txt_zwgx: 'Brak dostępnej aktualizacji',
    txt_dz: 'Kierownik sklepu',
    txt_sh: 'Kupiec',
    txt_dy: 'Pracownik',
    txt_bdsj: 'Bind telefon komórkowy',
    txt_shxx: 'Informacje o sprzedawcy',
    txt_shname: 'Nazwa sprzedawcy',
    txt_ssmd: 'Nazwa sprzedawcy',
    txt_bdsb: 'Urządzenie jest sparowane',
    txt_mendian: 'Warsztat',


    //数据总览模块
    txt_sTime: 'Wybierz okres',
    txt_car_check: 'Wskaźnik kontroli pojazdów',
    txt_findchance: 'Znajdź możliwości',
    txt_trackchace: 'Śledzenie możliwości',
    txt_transform: 'Kurs przeliczeniowy',
    txt_TotalData: 'Przegląd',
    txt_xxsj: 'Dane szczegółowe',
    txt_zhsj: 'Dane szczegółowe',
    txt_TireWear: 'Zużycie opon',
    txt_DataHopper: 'Lejkowanie danych',
    txt_jdcc: 'Liczba pojazdów przyjechała do sklepu',
    txt_CheckCar: 'Liczba kontroli pojazdów',
    txt_ChanceNum: "Leady sprzedażowe Q'ty",
    txt_TrackNum: 'Liczba śledzeń',
    txt_TranseformNum: 'Liczba konwersji',
    txt_UnTrack: 'Nie udało się namierzyć',
    txt_l: 'Pojazdy',
    txt_Time: 'Czas pomiaru',
    txt_Device: 'Nr seryjny Urządzenia',
    txt_car_plate: 'Numer rejestracyjny',
    txt_Wear: 'Całkowite zużycie',
    txt_Pwear: 'Nierównomierne zużycie',
    txt_NoData: 'Brak dostępnych danych',
    txt_GoodState: 'W dobrym stanie ',
    txt_Border: 'W dopuszczalnym stanie',
    txt_replace: 'Należy niezwłocznie wymienić',
    txt_Total_Check: 'Łączna liczba wykrytych pojazdów',
    txt_pmqk: 'Nierównomierne zużycie',
    txt_LightWear: 'Niewielkie zużycie ogumienia',
    txt_GraveWear: 'Poważne zużycie ogumienia',
    txt_hwtj: "Obrót Q'ty",
    txt_wxhw: 'Nie jest wymagana transpozycja',
    txt_xyhw: 'Wymagana transpozycja',
    txt_jcxq: 'Szczegóły',
    txt_zhxq: 'Szczegóły dotyczące konwersji;',
    txt_cc: 'Pojazdy',
    txt_bfb: '%',
    txt_ltxs: 'Sprzedaż opon',
    txt_sldw: 'Ustawienie czterech kół',
    txt_ddlph: 'Wyrównanie',
    txt_dphhh: 'Saldo',
    txt_qt: 'Inni',
    txt_zhqs: 'Trend konwersji',
    txt_ltxl: "Sprzedaż opon Q'ty",
    txt_ltfw: 'Serwis opon',
    txt_ckxq: 'Szczegóły',
    txt_jt: 'Dziś',
    txt_zt: 'Wczoraj',
    txt_bz: 'W tym tygodniu',
    txt_by: 'W tym miesiącu',
    txt_sy: 'W zeszłym miesiącu',
    txt_jn: 'W tym roku',
    txt_zhcl: 'Przeliczone pojazdy',
    txt_zhl: 'Kurs przeliczeniowy',
    txt_bfb: '%',
    txt_abjx: 'Rozkład pojazdu "Stanu granicznego"',
    txt_aljg: 'Dystrybucja pojazdu "Wymień natychmiast',
    txt_qwpm: 'Rozkład pojazdu "Nieznaczne nierównomierne zużycie"',
    txt_ayzp: 'Rozkład pojazdów "Poważne nierównomierne zużycie"',
    txt_lingt: '0 opona',
    txt_yt: '1 opona',
    txt_et: '2 opona',
    txt_st: '3 opona',
    txt_ft: '4 opona',

    //机会
    txt_xsjh: 'Leady sprzedażowe',
    txt_gzz: 'Namierzanie',
    txt_clwb: 'Proces jest zakończony',
    txt_ckbg: 'Sprawdź raport',
    txt_yxs: 'Wszystkie dane są wyświetlane',
    txt_zhuiz: 'Śledzenia',
    txt_tix: 'Przypominać',
    txt_chuli: 'Uchwyt',
    txt_yzh: 'Przekształcony',
    txt_wzh: 'Nieprzekonwertowane',
    txt_gzsmts: '{0} opona ma pewne problemy, {0} trafi do sklepu w celu naprawy.',
    txt_czbty: 'Nie zgadzam się',
    txt_yyx: 'Zdeterminowany',
    txt_ltyg: 'Jedna opona',
    txt_ltkg: 'Dwie opony',
    txt_ltsang: 'Trzy opony',
    txt_ltsig: 'Cztery opony',
    txt_jhcl: 'Korzystaj z możliwości',
    txt_jhztai: 'Status szans',
    txt_crquy: 'Obszar',
    txt_chuliry: 'Processer',
    txt_chulijg: 'Zamknięty',
    txt_zhuanhuanr: 'Treść konwersji',
    txt_zhuanhuaje: 'Ilość konwersji',
    txt_zhuanhuasj: 'Czas konwersji',
    txt_zhuanhuayx: 'Zdeterminowany',
    txt_xuanzesj: 'Proszę wybrać czas',
    txt_tsdatawk: 'Nie można zapisać danych, gdy "Stan możliwości" jest nieważny',
    txt_qtxzhsj: 'Podaj szacowany czas konwersji',
    txt_qtxzhnr: 'Proszę wypełnić treść konwersji',
    txt_qtxzhsj: 'Proszę wpisać czas konwersji',
    txt_sbts: 'Nie udało się zapisać danych, proszę sprawdzić sieć  ',


    //设备
    txt_sbgl: 'Zarządzanie urządzeniami',
    txt_tj: 'Dodawać ',
    txt_gdssb: 'Łączna liczba urządzeń {0}',
    txt_sbbh: 'Kod urządzenia',
    txt_gjbb: 'Wersja oprogramowania',
    txt_tjsj: 'Dodać czas',
    txt_zdgx: 'Automatyczna aktualizacja',
    txt_gxgj: 'Aktualizacja urządzenia',
    txt_jieb: 'Rozwiązać',
    txt_sbtsxx: 'Urządzenie ma aktualizacje, kliknij, aby zaktualizować',
    txt_wjh: 'Nieaktywny',
    txt_lix: 'Offline',
    txt_zaix: 'Online',
    txt_guz: 'Błąd',
    txt_yijieb: 'Bez ograniczeń',
    txt_yihuis: 'Recyklingowane',
    txt_gxsbgj: 'Uaktualnij urządzenie',
    txt_gxsbgjts: 'Czy chcesz uaktualnić urządzenie?',
    txt_socketdk: 'Nie udało się utworzyć połączenia komunikacyjnego z serwerem, proszę spróbować ponownie',
    txt_cscgts: 'Wyślij pomyślnie prośbę o aktualizację oprogramowania sprzętowego',
    txt_jbsb: 'Urządzenie odłączone',
    txt_jbsbts: 'Czy chcesz odłączyć urządzenie.',
    txt_tscg: 'Pomyślnie',
    txt_zdgxgj: 'Automatyczna aktualizacja',
    txt_gxgjts: 'Czy na pewno chcesz włączyć/wyłączyć funkcję automatycznej aktualizacji oprogramowania układowego?',
    txt_beiz: 'Uwagi',
    txt_qtxbz: 'Proszę wypełnić uwagi',
    txt_bdsbts: 'Aplikacja jest używana tylko dla urządzenia [Międzynarodowa Wersja Ręcznego Wykrywania Opon], upewnij się, że model urządzenia, który chcesz oprawić, jest prawidłowy.',
    txt_qdksb: 'Proszę najpierw włączyć urządzenie',
    txt_dksbts1: '1、Nowe urządzenie, po włączeniu automatycznie przejdzie do "Przewodnika parowania"',
    txt_dksbts2: '2、Jeśli urządzenie było wcześniej wiązane z innymi magazynami, proszę kliknąć "Odparowanie urządzenia" w menu "Ustawienia" urządzenia, aby je rozpiąć, wówczas urządzenie automatycznie przejdzie do "Przewodnika Parowania"',
    txt_yjdksblw: 'Włączyłem urządzenie i podłączyłem się do sieci',
    txt_xyb: 'Dalej',
    txt_qsclj: 'Zeskanuj kod QR',
    txt_qscts1: 'Użyj urządzenia do zeskanowania kodu QR, jeśli operacja skanowania zostanie umiań, urządzenie wyemichuje',
    txt_qscts2: 'Skanowanie zakończone pomyślnie',
    txt_sbtssmcg: 'Skanowanie zakończone pomyślnie',
    txt_ddsblw: 'Oczekiwanie na połączenie sieciowe',
    txt_zznlbd: 'Proszę czekać',
    txt_qszdd: 'To może zająć dziesiątki sekund, proszę poczekać.',
    txt_bdcg: 'Added successfully',
    txt_tjcg: 'Added successfully',
    txt_tjcgts: 'Gratulacje, urządzenie dodane pomyślnie. Proszę zwrócić uwagę na urządzenie, aby ułatwić identyfikację',
    txt_fhsblb: 'Powrót do listy urządzeń',
    txt_jxtjsb: 'kontynuować',
    txt_bzmc: 'Urządzenie do uwagi',


    //检测记录
    txt_sx: 'Ekran',
    txt_khsj: 'Telefon komórkowy klienta',
    txt_cphm: 'Numer rejestracyjny',
    txt_cphm1: 'tablica rejestracyjna',
    txt_clxh: 'Model samochodu',
    txt_xgbz: 'Modyfikowanie notatek',
    txt_gtfjl: 'Suma raportów',
    txt_jcsj: 'Czas pomiaru',
    txt_jcsj1: 'Czas detekcji',
    txt_xzkssj: 'Wybierz czas rozpoczęcia',
    txt_xzjssj: 'Wybierz czas końcowy',
    txt_jcjg: 'Wyniki wykrywania',
    txt_msqk: 'Zużycie bieżnika',
    txt_jygh: 'Zastąpić',
    txt_zysh: 'Granica',
    txt_zcsy: 'Normalny',
    txt_zc: 'Normalne',
    txt_hs: 'Poprawny',
    txt_cz: 'Zresetować',
    txt_qd: 'Potwierdzić',
    txt_jcjgd: 'Wyniki wykrywania',
    txt_msqkd: 'Zużycie bieżnika',
    txt_sldwd: 'Ustawienie czterech kół',
    txt_jyghd: 'Zalecana jest wymiana',
    txt_zysh: 'Zwróć uwagę',
    txt_zcsyd: 'Normalny',
    txt_xdwd: 'Potrzebne jest wyrównanie',
    txt_xzyd: 'Zwróć uwagę',
    txt_zcd: 'Normalne',
    txt_bgxq: 'Szczegóły sprawozdania',
    txt_ljdy: '连接打印',
    txt_fwmd: 'Serwis',
    txt_mddz: 'Adres serwisu',
    txt_jcsb: 'Urządzenie testowe',
    txt_ddmd: 'Cel wizyty w warsztacie',
    txt_lic: 'Przebieg pojazdu',
    txt_chex: 'Model samochodu',
    txt_jcjyi: 'Zalecenie',
    txt_ysbs: 'Identyfikacja kolorów',
    txt_ztms: 'Całkowite zużycie',
    txt_hwms: 'Ekscentryczny stan zużycia',
    txt_dqscjltx: 'Ostrzeżenie dotyczące aktualnej drogi hamowaniaa',
    txt_bgxqts: ' DELETE',
    txt_wxsmgz: 'DELETE',
    txt_hwmsjh: 'Zużycie bieżnika równomierne',
    txt_zqlun: 'Lewe przednie koło',
    txt_zhlun: 'Lewe tylne koło',
    txt_yqlun: 'Prawe przednie koło',
    txt_yhlun: 'Prawe tylne koło',
    txt_pingjunzhi: 'Wartość średnia:',
    txt_guige: 'Specyfikacje',
    txt_gongli: 'KM',
    txt_ltwjc: 'Nie wykryto żadnej opony',
    txt_pinpai: 'Marka',
    txt_ltws: 'Wygląd opony',
    txt_sewmts: 'Zeskanuj kod QR\naby wyświetlić raport',
    txt_print: 'Print',





    //店员管理
    txt_xz: 'Dodawać',
    txt_qy: 'Aktywny',
    txt_qyz: 'Roboczy',
    txt_ty: 'Wyłączony z eksploatacji',
    txt_yhzh: 'Konto użytkownika',
    txt_lxfs: 'Dane kontaktowe',
    txt_cjsj: 'Czas tworzenia',
    txt_bjxx: 'Redagować',
    txt_xgmm: 'Zmodyfikuj hasło',
    txt_bgzt: 'Zmiana statusu',
    txt_qdytjm: 'Pamiętaj, aby wyłączyć konto？',
    txt_tjdy: 'Dodaj pracownika',
    txt_bjdyxx: 'Edytowanie informacji o pracownikach',
    txt_zhxx: 'Informacje o koncie',
    txt_ygxm: 'Imię i nazwisko pracownika',
    txt_qtxygxm: 'Proszę wpisać nazwisko pracownika',
    txt_lxdh: 'Informacje kontaktowe',
    txt_qtxyglxdh: 'Numer',
    txt_dxyzm: 'Kod weryfikacji SMS',
    txt_qtxdxyzm: 'Proszę wypełnić kod weryfikacyjny SMS',
    txt_fsdx: 'Wyślij SMS',
    txt_tjzh: 'Dodaj konto',
    txt_baocun: 'Zapisać',
    txt_gtgygzh: ' {0}Rachunki ogółem',



    //登录
    txt_qdytcdlm: 'Gotowy do wylogowania',
    txt_qx: 'Anuluj',
    txt_dl: 'Zaloguj się',
    txt_qsrzh: 'Podaj identyfikator konta',
    txt_qsrmm: 'Proszę podać swoje hasło',
    txt_zcshzh: 'Zarejestruj się jako sprzedawca',
    txt_shzhwjmm: 'Zapomniałem passowrd',
    txt_yzdqmm: 'Weryfikacja aktualnego hasła',
    txt_szxmm: 'Ustaw nowe hasło',
    txt_xgcg: 'Zmodyfikowany pomyślnie',
    txt_qtxjmm: 'Proszę wprowadzić stare hasło',
    txt_yzzcsj: 'Zweryfikuj zarejestrowany telefon komórkowy',
    txt_qtxxmm: 'Wprowadź nowe hasło',
    txt_qzctxxmm: 'Powtórz nowe hasło',
    txt_lcmmsrbyz: 'Te dwa hasła są niespójne',
    txt_gxnxgcg: 'Hasło zmodyfikowane pomyślnie',
    txt_qljndxmm: 'Zapamiętaj swoje nowe hasło',
    txt_fhgrzx: 'Powrót do centrum osobistego',
    txt_fsyzm: 'Wyślij kod weryfikacyjny',
    txt_qtxzcsjh: 'Proszę wpisać numer rejestracyjny telefonu komórkowego',
    txt_qtxtxyzm: 'Proszę wypełnić kod graficzny',
    txt_qsryzm: 'Proszę wprowadzić kod weryfikacyjny',
    txt_qszhhmm: 'Ustaw hasło składające się z 6 do 18 cyfr i liter',
    txt_qzcsrmm: 'Powtórz hasło',
    txt_lcmmbyz: 'Te dwa hasła są niespójne',
    txt_hdsy: 'Powrót do strony głównej',
    txt_zcshh: 'Zarejestruj się jako sprzedawca',
    txt_fhdl: 'Powrót do strony logowania',
    txt_wlqqsb: 'Internet nienormalny, spróbuj ponownie',
    txt_wczc: 'Rejestracja zakończona',
    txt_wsts: ' Zakończ inne informacje przed rozpoczęciem korzystania z aplikacji.',
    txt_qtxshmc: 'Proszę wpisać nazwę sprzedawcy',
    txt_shmc: 'Nazwa sprzedawcy',
    txt_rgszjd: 'Takie jak numer telefonu stacjonarnego, inny numer telefonu, faks itp',
    txt_qtlxfs: 'Pozostałe informacje kontaktowe',
    txt_kssy: 'Zacznij używać',
    txt_Pwear1: 'Zużycie ekscentryczne',
    txt_open: 'Otwierać',
    txt_close: 'Zamykać',
    txt_srczhdmm: 'Wpisz nowe hasło',
    txt_kcfs: '{0} s',
    txt_xiugai: 'Modyfikacja',
    txt_zzjzsj: 'Ładowania',
    txt_bjshxx: 'Edytowanie informacji o sprzedawcy',
    txt_chongxinhq: 'Wyślij ponownie',
    txt_gaibangsj: 'Modyfikowanie telefonu komórkowego',
    txt_yanzhengjsj: 'Zweryfikuj stary telefon komórkowy',
    txt_bangdingxsj: 'Powiąż z nowym telefonem komórkowym',
    txt_yhqsyxsjdl: 'Zaloguj się przez nowy telefon komórkowy',



    //登录新
    txt_xzshenfen: 'Wybierz swoją rolę',
    txt_dlrolewz: 'Zaloguj się {0} konto  ',
    txt_qsrsjh: 'Proszę podać numer telefonu komórkowego',
    txt_zhuce: 'Rejestr',
    txt_wanjimima: 'Zapomnij o haśle',
    txt_wanshandzxx: 'Uzupełnij informacje o koncie kierownika sklepu',
    txt_qsrxm: 'Wpisz swoje imię i nazwisko',
    txt_qsrmdm: 'Proszę wpisać nazwę sklepu',
    txt_qsrmdgddh: 'Proszę wpisać numer telefonu stacjonarnego sklepu',
    txt_qsrmddz: 'Proszę podać adres sklepu',
    txt_qsrgsdz: 'Proszę podać adres firmy',
    txt_qsrxxdz: 'Proszę podać szczegółowy adres',
    txt_tijiaocg: 'Zgłoś się z powodzeniem',
    txt_qsvbsylwmm: 'Hasło nie mniej niż 6 cyfrowych ',
    txt_zhucerole: 'Rejestrować ',
    txt_qsrshh: 'Proszę podać numer konta handlowego',
    txt_qsrdzh: 'Proszę wprowadzić numer konta kierownika sklepu',
    txt_wsshhzl: 'Uzupełnij informacje o koncie handlowym',
    txt_wsdyhzl: 'Uzupełnij informacje o rachunku bankowym',
    txt_qsrshm: 'Podaj nazwę sprzedawcy (nazwa firmy)  ',
    txt_qsrshz: 'Podaj właściciela sprzedawcy  ',
    txt_qsrzrqy: 'Proszę wejść do obszaru woring ',
    txt_shanghudizhi: 'Adres kupca',
    txt_yhycz: 'Użytkownik już istnieje',
    txt_qsrzqdzh: 'Proszę wpisać prawidłowy numer konta kierownika sklepu',
    txt_qsrzqshh: 'Proszę wpisać prawidłowy numer konta handlowego',
    txt_xzmdcx: 'Wybierz zapytanie do sklepu',



    //门店
    txt_mendianId: 'Identyfikator sklepu',
    txt_mendianmc: 'Serwis',
    txt_mendiandz: 'Adres serwisu',
    txt_mendiandh: 'Numer telefonu sklepu.',
    txt_caozuo: 'Działanie',
    txt_mendiangl: 'Zarządzanie magazynem',
    txt_gjmendian: '{0} Sklepy ogółem',
    txt_zhengchangyy: 'Normalnie otwarte',
    txt_tingye: 'Zamknij',
    txt_gengdxx: 'Więcej',
    txt_dianygl: 'Kierownictwo urzędnicze',
    txt_biangzt: 'Zmiana statusu',
    txt_qdygbzhuangtai: 'Pamiętaj, aby wyłączyć sklep？',
    txt_bjmendian: 'Edytuj informacje o sklepie',
    txt_xinzenmd: 'Dodaj nowy sklep  ',
    txt_qtxmdmc: 'Proszę podać nazwę sklepu.',
    txt_qxzmddz: 'Wybierz adres sklepu',
    txt_qtxxdz: 'Proszę podać adres sklepu',
    txt_xiangxidz: 'Szczegółowy adres',
    txt_qtxmddh: 'Proszę podać numer telefonu sklepu',
    txt_dzxx: 'Informacje o menedżerze',
    txt_chaungjianmendian: 'Utwórzcie sklep',
    txt_mendianxxxx: 'Szczegółowe informacje',
    txt_bianji: 'Redagować',
    txt_mendianzt: 'Status sklepu',

    //商户数据总览
    txt_mendianshuju: 'Przechowywanie danych',
    txt_chakangdxxbb: 'Sprawdź więcej raportów',
    txt_jczcs: 'Całkowita kontrola',
    txt_mdpjjc: 'Średnia kontrola',
    txt_jdzcl: 'Całkowity przepływ pojazdu',
    txt_jcl: 'Wskaźnik kontroli',
    txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
    txt_xyghltjgfb: '需更换轮胎的结果分布',
    txt_xzzyltjgfb: '需注意轮胎的结果分布',
    txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
    txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
    txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
    txt_jrzl: 'Przegląd',
    txt_xiangqbb: 'Szczegóły',
    txt_xuanzerqckxxsj: 'Wybierz datę',
    txt_qxzsjd: 'Wybierz okres',
    txt_sjdts: 'Możesz wybrać tylko okres krótszy niż 30 dni',
    txt_zonglan: 'Przegląd',
    txt_qushi: 'Tendencja',
    txt_shuliangtj: 'Statystyki ilościowe',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: "Trend inspekcji Q'ty",
    txt_msqkslqs: 'Trend zużycia opon',
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: "Całkowita kontrola Q'ty",
    txt_shuliang: "Q'ty",
    txt_zhanbi: '%',
    txt_chankangd: 'Więcej',
    txt_chakanmdxxbb: 'Szczegóły',


    //国家
    txt_zhongguo: 'China',
    txt_mlxy: '马来西亚',
    txt_yindu: '印度',
    txt_taiguo: '泰国',
    txt_oluosi: '俄罗斯',



    txt_taici: 'Liczba stacji',
    txt_jianyi: 'wniosek:',
    txt_jianyineirong: 'opona ma ekscentryczne zużycie, zaleca się dalszą kontrolę.',
    txt_jianyineirongzc: 'normalne',
    txt_bgtixing: 'Przypominanie:',
    txt_bgtuxubfnr: 'Obecne zużycie opon może spowodować wydłużenie drogi hamowania o {0}% (szacunkowo)',
    txt_waishang: 'Uraz',
    txt_laohua: 'Zużycie',
    txt_gubao: 'Pęcherz',
    txt_xichemeirong: 'Myjnia samochodowa',
    txt_weixiubaoyang: 'Konserwacja',
    txt_guenghuanluntai: 'Wymiana opon',
    txt_tireservice: 'Serwis opon',
    txt_scsltjcy: 'Ręczny wykrywacz opon',
    txt_shijiantishi: 'Czas rozpoczęcia musi być krótszy niż czas zakończenia',

    txt_qxzclry: 'Proszę wybrać osobę odpowiedzialną za obsługę',

    txt_lf_outworn: 'Zewnętrzna strona lewego przedniego koła zużywa się poważniej niż strona wewnętrzna',
    txt_lf_innerworn: 'Wewnętrzna strona lewego przedniego koła jest zużyta poważniej niż strona zewnętrzna',
    txt_lf_bothsideworn: 'Obydwie ściany boczne lewego przedniego koła są zużyte poważniej niż bieżnik',
    txt_lf_centreworn: 'Bieżnik lewego przedniego koła jest zużyty poważniej niż obie ściany boczne',
    txt_lb_outworn: 'Zewnętrzna strona lewego tylnego koła zużywa się poważniej niż strona wewnętrzna',
    txt_lb_innerworn: 'Strona wewnętrzna lewego tylnego koła jest zużyta poważniej niż strona zewnętrzna',
    txt_lb_bothsideworn: 'Obie ściany boczne lewego tylnego koła są zużyte poważniej niż bieżnik',
    txt_lb_centreworn: 'Bieżnik lewego tylnego koła jest zużyty poważniej niż obie ściany boczne',
    txt_rb_outworn: 'Zewnętrzna strona prawego tylnego koła jest zużyta poważniej niż strona wewnętrzna',
    txt_rb_innerworn: 'Wewnętrzna strona prawego tylnego koła jest zużyta poważniej niż strona zewnętrzna',
    txt_rb_bothsideworn: 'Obydwie ściany boczne prawego tylnego koła są zużyte poważniej niż bieżnik',
    txt_rb_centreworn: 'Bieżnik prawego tylnego koła jest zużyty poważniej niż obie ściany boczne',
    txt_rf_outworn: 'Zewnętrzna strona prawego przedniego koła zużywa się poważniej niż strona wewnętrzna',
    txt_rf_innerworn: 'Wewnętrzna strona prawego przedniego koła jest zużyta poważniej niż strona zewnętrzna',
    txt_rf_bothsideworn: 'Obydwie ściany boczne prawego przedniego koła są zużyte poważniej niż bieżnik',
    txt_rf_centreworn: 'Bieżnik prawego przedniego koła jest zużyty poważniej niż obie ściany boczne',
    txt_tire_need_replace: 'Opona jest poważnie zużyta, zalecamy jej wymianę.',

    txt_alignment_chassis: 'Zalecamy dalsze sprawdzanie osiowania czterech kół lub badania podwozia',

    txt_do_further_check: 'wykonaj dalsze sprawdzenie',
    txt_uneven_check: 'Zużycie opon jest nieprawidłowe, zalecane jest wyrównanie i równowaga.  ',
    txt_tire_rotation: 'Zalecamy obracanie opon',
    txt_wear_normal: 'Zużycie opony normalne  ',
    'txt_wear_normal;': 'Zużycie opony normalne  ',
    txt_tire: 'Opona ',
    txt_xiazai: 'Pobierać  ',
    txt_xiazaishibai: 'Pobieranie nie powiodło się  ',
    txt_appname: 'Leadshub',
    txt_dianjixiazaiandroid: 'Pobierz wersję Androida',
    txt_dianjixiazaiios: 'Pobierz wersję na iOS',






    txt_gelie: 'podziel',
    txt_diaokuai: 'upuszczanie bloków',
    txt_chaungci: 'punktacja',
    txt_cashang: 'zadrapanie',
    txt_yichang: 'wyjątek',
    txt_qjybjcltazqk: 'Proszę sprawdzić instalację opony',
    txt_wear_overall: 'Ogólne zużycie eksploatacyjne',
    txt_pattern_wear: 'Nietypowe zużycie',
    txt_tire_age: 'Wiek opony',
    txt_tire_appearance: 'Wygląd opony',
    txt_tire_age_5: 'Opona DOT ma ponad 5 lata, zalecana jest wymiana opon.',
    txt_tire_age_3: 'Opona DOT ma ponad 3 lata, proszę regularnie sprawdzać.',
    txt_tire_age_8: 'Opona DOT ma ponad 8 lata, zalecana jest wymiana opon.',
    txt_tire_age_6: 'Opona DOT ma ponad 6 lata, zalecana jest wymiana opon.',
    txt_tire_age_ok: 'Opona DOT jest dobra.',
    txt_tire_trauma_check: 'Opona ma uszkodzenia, proszę sprawdzić.',
    txt_install_abnormal_check: 'Opona jest zamontowana odwrotnie, proszę to sprawdzić',
    txt_tire_appearance_ok: 'Opona nie posiada uszkodzeń',
    txt_ltlcgstm: 'Zgodnie z aktualnym stanem zużycia opon, zakres opon wynosi {0} km (wartość szacunkowa)',
    'txt_tire_need_replace;': 'Opona jest poważnie zużyta, zalecamy jej wymianę.',
    'txt_uneven_check;': 'Jeżeli opona jest uszkodzona nieprawidłowo, zaleca się sprawdzenie równowagi dynamicznej, ustawienia i układu zawieszenia',
    txt_tire_rotation: 'Zalecamy obracanie opon',   
    'txt_tire_age_ok': 'Opona nie przekroczyła swojej granicy wieku',
    'txt_wear_uniform;': 'Jednolite zużycie pojedynczej opony',
    txt_wear_uniform: 'Jednolite zużycie pojedynczej opony',
    'txt_tire_boundary;': 'Opona jest zużyta do stanu granicznego',
    txt_tire_boundary: 'Opona jest zużyta do stanu granicznego',
    txt_plcl: 'Przetwarzanie wsadowe',
    txt_qbxz: 'Wybierz wszystkich',
    txt_scjcjg: 'Oszacowanie przebiegu wytrzymałościowego opony',
    txt_ltxhlcgs: 'Oszacowanie przebiegu wytrzymałościowego opony',
    txt_ltazhuang: 'Montaż opon:',
    txt_dqltlctx: 'Aktualna opona osiągnęła limit wieku, należy ją natychmiast wymienić',
    txt_dottx: 'szacowanie okresu eksploatacji opon',
    txt_danweinian: '(jednostka: rok)',
    txt_danweikm: '(jednostka: km)',
    txt_myhqdsj: 'To nie jest czas, aby dostać DOT',
    txt_dotjstx: 'Czas eksploatacji opony pozostaje {0} dni według czasu DOT, proszę zwrócić uwagę i sprawdzić',
    txt_dotjstx2: 'Opona była używana przez ponad 5 lat po wygaśnięciu jej ważności, zalecamy jej wymianę',
    txt_dotsjztx: '(DOT: Data Produkcji Opon)',
    'txt_tire_age_ok;': 'Opona nie przekroczyła swojej granicy wieku',


    //微信公众号
    txt_mdmz: '门店姓名',
    txt_mddzz: '门店地址',
    txt_sbid: '设备ID',
    txt_jsxm: '技师姓名',
    txt_shoujhm: '手机号码',
    txt_dxyzmm: '短信验证码',


    txt_jishimz: 'Technik',
    txt_ltlcgsnew: 'Zakres opon wynosi {0} km',
    txt_ltlcgsnewin: 'Tire range is {0} miles',
    txt_pinnate_wear: 'noszenie piór',
    txt_msjxtx: 'opona osiągnęła limit, proszę ją natychmiast wymienić',
    txt_ltfz: 'na odwrót',
    txt_install_check: 'Kontrola montażu',
    txt_install_ok: 'Montaż opony poprawny',
    LF: '[lewe przednie koło]',
    RF: '[prawe przednie koło]',
    LB: '[tylne lewe koło]',
    RB: '[prawe tylne koło]',
    FF: '[oś przednia]',
    BB: '[oś tylna]',
    txt_appearance_check: 'Opona jest uszkodzona, proszę naprawić i potwierdzić',
    txt_uneven_center: 'Nieprawidłowe zużycie w środku opony. Zaleca się sprawdzenie ciśnienia w oponie',
    txt_uneven_out: 'Zewnętrzna strona opony jest normalnie zużyta. Zaleca się sprawdzić ustawienie czterech kół i ciśnienie opony',
    txt_pinnate_check: 'Istnieje zużycie piór na oponie, więc zaleca się dalsze sprawdzenie części podwozia',
    txt_uneven_inside: 'Jeśli wewnętrzna strona opony jest normalnie zużyta, zaleca się sprawdzenie ustawienia i ciśnienia w oponach.',
    'txt_do_further_check;': 'Więcej informacji',
    txt_uneven_bothside: 'Nieprawidłowe zużycie po obu stronach opony. Zaleca się sprawdzenie ustawienia i ciśnienia w oponach。',

    txt_msyzljgh: 'Opona jest poważnie zużyta. Proszę ją natychmiast wymienić.',
    txt_serious_trauma_check: "Opona ma poważne obrażenia. Zaleca się wymianę opony",
    txt_appearance_lookup: "Proszę sprawdzić wygląd opony",
    txt_wear_lookup: "Proszę sprawdzić zużycie opon.",
    txt_dotscsj: 'Czas produkcji: {0} ({2} tydzień {1} roku',
    txt_whqdscsj: 'Nie uzyskano czasu produkcji',
    purp_tireservice: 'Serwis opon',
    purp_vehicle_inspection: 'Kontrola pojazdu',

    txt_qiao: 'Oś',
    txt_left: 'Lewy',
    txt_right: 'Prawy',
    txt_lun: 'Opona',
    txt_huawen: 'Bieżnik opony',
    txt_taihao: 'Nr opony',
    txt_taiya: 'Ciśnienie w oponach',
    txt_chexlw: 'Model samochodu i położenie koła',
    txt_jiancerenyuan: 'Inspektor',
    txt_beitai: 'Koło zapasowe',
    txt_tuoche: 'Traktor',
    txt_guache: 'Przyczepa',
    txt_chassis_check: 'Kontrola podwozia',
    txt_chassis_ok: 'podwozie jest w dobrym stanie',
    txt_chassis_oil: 'Wstrząsający pochłaniacz wycieka oleju. Zaleca się dalsze potwierdzenie i zastąpienie go w razie potrzeby.',
    txt_chassis_aging: 'Gumka głowy wału się starzeje, więc zaleca się go zastąpić。',
    txt_chassis_more: 'Gumka głowicy osi starzeje się i wyciek oleju z amortyzatora jest nieprawidłowy, więc zaleca się naprawę',
    chassis_oil:'wyciek oleju z amortyzatora',
    chassis_aging:'starzenie się gumy trzonkowej',
    chassis_normal:'normalne',
    
    txt_hood:'Pokrywa silnika',
    txt_wash_liquid:'Woda wycieraczek',
    txt_level_control:' Kontrola poziomu',
    txt_haoxiaoxi:'Normalne',
    txt_vedi_Note:'Sprawdzanie ręczne ',
    txt_replace1:'Zastępstwo',
    txt_radiator_fluid:'Płyn do chłodnic',
    txt_engine_oil:'Olej silnikowy',
    txt_brake_fluid:'Płyn hamulcowy',
    txt_quality_control:'Kontrola jakości',
    txt_multimeter:'Multimetr',
    txt_subtotal:'Kwota',
    txt_shock_absorber:'Amortyzator',
    txt_check_loss:' Czek zagubiony',
    txt_brake_disc:' Hamulcowa',
    txt_wear_condition:'Stan zużycia ',
    txt_brake_pads:'Klocki hamulcowe',
    txt_change_control:'Inny system sterowania',
    txt_air_control:'Klimatyzator',
    txt_last_reload:'Ostatni raz ładowanie',
    txt_lighting:'Oświetlenie',
    txt_verification1:'Wycieraczki',
    txt_dynamometer:'Dynamomter',
    txt_batteria:'Bateria',
    txt_verification:'Uruchamianie weryfikacji',
    txt_levellow:'OK',
    txt_levelmiddle:'Sprawdzanie ręczne',
    txt_levelhigh:'Zastępstwo',
    txt_tyrenumber:'Głębokość skanowania:',
    txt_cormach_title:'Zużycie i nierównomierne zużycie',
    txt_wearlow:'Jednolite zużycie wzoru',
    txt_wearmiddle:'lekkie zużycie',
    txt_wearhigh:'Ciężkie zużycie',
    txt_namtishi:'1/32',
    txt_trauma_eattyre:'Poważne zużycie unvnen',
    txt_uneven_eattyre:'Opona jest poważnie nierównomiernie zużyta, proszę sprawdzić układ zawieszenia',
    txt_appearance_eattyre:'Opona jest poważnie nierównomiernie zużyta, proszę sprawdzić układ zawieszenia',
    txt_chassis_eattyre:'Opona jest poważnie nierównomiernie zużyta, proszę sprawdzić układ zawieszenia',
    txt_uneven_high_eattyre:'Opona jest poważnie nierównomiernie zużyta, proszę sprawdzić układ zawieszenia',
    txt_appearance_high_eattyre:'Opona jest poważnie nierównomiernie zużyta, proszę sprawdzić układ zawieszenia',
    txt_chassis_high_eattyre:'Opona jest poważnie nierównomiernie zużyta, proszę sprawdzić układ zawieszenia',
    txt_chassis_uneven:'Opona jest poważnie nierównomiernie zużyta, proszę sprawdzić układ zawieszenia',
    txt_pianmoyichang:'Opona jest poważnie nierówna zużycie',


    txt_khxm:'Customer Name',
    txt_khyx:'Customer Mail',
}


// WEBPACK FOOTER //
// ./src/i18n/pl.js